class ProductCustomEngraving extends HTMLElement {
  constructor() {
    super();
    this.onTextInputChange = this.onTextInputChange.bind(this);
    this.onSaveBtnClick = this.onSaveBtnClick.bind(this);
    this.updateQty = this.updateQty.bind(this);
    this.clearTextInput = this.clearTextInput.bind(this);
    this.onVariantChange = this.onVariantChange.bind(this);
  }

  connectedCallback() {
    this.textInput = this.querySelector('input[type="text"]');
    this.inputs = this.querySelectorAll('input, select, textarea');
    this.charsNum = this.querySelector('#chars-num');
    this.clearBtn = this.querySelector('#clear-btn');
    this.saveBtn = this.querySelector('#save-btn');
    this.modalCloseBtn = this.querySelector(this.dataset.modalCloseBtn);
    
    this.productCustomEngravingElem = document.getElementById(this.dataset.engravingElemId);
    
    if (this.productCustomEngravingElem) {
        this.popUpTitleElem = this.productCustomEngravingElem.querySelector(this.dataset.titleElemSelector);
        this.popupBtnElem = this.productCustomEngravingElem.querySelector(this.dataset.btnSelector);
        this.editBtn = this.productCustomEngravingElem.querySelector("#edit-btn");
    }

    this.defaultTitle = this.dataset.defaultTitle || 'Add Engraving'; 

    if (this.textInput) this.textInput.addEventListener('input', this.onTextInputChange);
    if (this.saveBtn) this.saveBtn.addEventListener('click', this.onSaveBtnClick);
    if (this.clearBtn) this.clearBtn.addEventListener('click', this.clearTextInput);

    if (this.charsNum) this.charsNum.innerText = 0;

    document.addEventListener('variant:change', this.onVariantChange);
  }

  disconnectedCallback() {
    document.removeEventListener('variant:change', this.onVariantChange);

    if (this.textInput) this.textInput.removeEventListener('input', this.onTextInputChange);
    if (this.saveBtn) this.saveBtn.removeEventListener('click', this.onSaveBtnClick);
    if (this.clearBtn) this.clearBtn.removeEventListener('click', this.clearTextInput);
    
    if (this.productQtyInput) {
        this.productQtyInput.removeEventListener('change', this.updateQty);
    }
  }

  onTextInputChange(event) {
    const value = event.target.value;
    if (this.charsNum) this.charsNum.innerText = value.length;

    if (this.clearBtn) {
      const isHidden = value.length === 0;
      this.clearBtn.classList.toggle('hidden', isHidden);
      this.clearBtn.setAttribute('aria-hidden', isHidden);
    }
  }

  onSaveBtnClick() {
    const hasText = this.textInput.value.length > 0;

    this.inputs.forEach((input) => {
      if (hasText) {
        if (!input.name && input.dataset.name) input.name = input.dataset.name;
      } else {
        if (input.name) input.removeAttribute('name');
      }
    });

    if (this.popUpTitleElem) {
      this.popUpTitleElem.innerText = hasText ? this.textInput.value : this.defaultTitle;
      this.popUpTitleElem.classList.toggle('body-medium', !hasText);
      this.popUpTitleElem.classList.toggle('body-regular', hasText);
    }
    
    if (this.editBtn) this.editBtn.classList.toggle('hidden', !hasText);
    if (this.popupBtnElem) this.popupBtnElem.classList.toggle('saved', hasText);

    if (this.modalCloseBtn) this.modalCloseBtn.click();
  }

  updateQty(event) {
    const qtyInput = this.querySelector('[data-qty]');
    if(qtyInput) qtyInput.value = event.target.value;
  }

  clearTextInput() {
    if(!this.textInput) return;
    this.textInput.value = '';
    this.textInput.dispatchEvent(new Event('input', { bubbles: true }));
  }

  getEngravingVariantMap() {
    if (this.engravingVariantMap === undefined) {
      const mapElem = this.querySelector('[data-engraving-variant-map]');
      try {
        this.engravingVariantMap = mapElem ? JSON.parse(mapElem.textContent) : null;
      } catch (error) {
        this.engravingVariantMap = null;
      }
    }

    return this.engravingVariantMap;
  }

  refreshEngravingTimestamps() {
    const timestampInputs = this.querySelectorAll('[data-engrave-ts-input], [data-engraving-ts-input]');
    const previous = parseInt(timestampInputs[0]?.value || this.combinedInput?.dataset.engravingTimestamp, 10);

    // Kept in epoch seconds to match the value Liquid renders.
    let timestamp = Math.floor(Date.now() / 1000);
    if (previous && timestamp <= previous) timestamp = previous + 1;

    const value = String(timestamp);

    timestampInputs.forEach((input) => {
      input.value = value;
    });

    if (this.combinedInput) this.combinedInput.dataset.engravingTimestamp = value;
  }

  onVariantChange(event) {
    const variant = event.detail?.variant;
    if (!variant) return;

    if (event.detail.sectionId && this.dataset.sectionId && event.detail.sectionId !== this.dataset.sectionId) return;

    const variantMap = this.getEngravingVariantMap();
    const mappedVariant = variantMap ? variantMap[variant.id] : null;
    let title;
    let sku;

    if (mappedVariant) {
      title = mappedVariant.title;
      sku = mappedVariant.sku;
    } else {
      const targetVariants = this.dataset.engravingTargetVariants;
      if (targetVariants && !targetVariants.split(',').includes(String(variant.id))) return;

      title = variant.name;
      sku = variant.sku;
    }

    const titleInput = this.querySelector('[data-main-product-title]') || this.titleSource;
    const refInput = this.querySelector('[data-main-product-ref]') || this.refSource;

    if (titleInput) titleInput.value = title || '';
    if (refInput) refInput.value = sku || '';

    this.refreshEngravingTimestamps();

    if (this.combinedInput && this.combinedInput.value && this.textInput?.value) {
      this.combinedInput.value = this.buildCombinedValue();
    }
  }
}

customElements.define('product-custom-engraving-modal', ProductCustomEngraving);